import { BonusItem } from "@/models/bonus-items.model";
import React, { useEffect, useState } from "react";
import PayItemDialogContainer from "../../dialog/PayItemDialogContainer";
import AddBonusFrom from "./AddBonusForm";
import PayItemDataTable from "../../PayItemDataTable";
import { getColumns } from "./columns";
import { getBonusItems } from "@/api/bonus-items";

interface Props {
  userId: number;
  month: number;
  year: number;
  payslipId?: number;
}

function BonusTab({ userId, month, year, payslipId }: Props) {
  const [bonusItems, setBonusItems] = useState<BonusItem[]>([]);

  const updateBonusItems = (bonusItem: BonusItem) => {
    setBonusItems([...bonusItems, bonusItem]);
  };

  const deleteBonusItem = (id: number) => {
    const updatedItems = bonusItems.filter((item) => item.id !== id);
    setBonusItems(updatedItems);
  };

  useEffect(() => {
    const fetchBonusItems = async () => {
      const res = await getBonusItems({ userId, month, year });
      setBonusItems(res);
    };
    fetchBonusItems();
  }, [userId, month, year]);

  return (
    <div className="flex flex-col gap-3 p-5">
      <div className="flex justify-between">
        <div>
          <div className="text-lg font-bold">Bonus Items (CPF)</div>
          <div className="w-full flex flex-col">
            <div>Includes Commission, Bonus, Leave pay etc.</div>
          </div>
        </div>
        <PayItemDialogContainer
          title="Add Bonus Item"
          description="Includes Commission, Bonus, Leave pay etc."
          form={
            <AddBonusFrom
              userId={userId}
              month={month}
              year={year}
              payslipId={payslipId}
              updateBonusItems={updateBonusItems}
            />
          }
        />
      </div>

      <PayItemDataTable
        columns={getColumns(deleteBonusItem)}
        data={bonusItems}
        header="Current items"
      />
    </div>
  );
}

export default BonusTab;
